<template>
    <!-- App Header -->
    <SideHeader :to="'/'" />
    <!-- * App Header -->

    <!-- App Capsule -->
    <div style="padding-top: 55px;">
        <ListView v-if="loading" />
        <div v-else class="section full mt-2 mb-2">
            <div class="section-title">جستجو استانی</div>
            <div class="wide-block pt-2 pb-1">
                <div class="container">
                    <form>
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="form-label fw-bold" for="from">مبدا</label>
                                <select class="form-control form-select" id="from"
                                    v-model="postData.selectedLoadingCitiesIds">
                                    <option selected value="">همه</option>
                                    <option v-for="result in results" :key="result.id" :value="result.id">
                                        {{ result.name }}
                                    </option>
                                </select>
                                <i class="clear-input">
                                    <ion-icon name="close-circle"></ion-icon>
                                </i>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="form-label fw-bold" for="to">مقصد</label>
                                <select class="form-control form-select" id="to"
                                    v-model="postData.selectedDischargeCitiesIds">
                                    <option selected value="">همه</option>
                                    <option v-for="result in results" :key="result.id" :value="result.id">
                                        {{ result.name }}
                                    </option>
                                </select>
                                <i class="clear-input">
                                    <ion-icon name="close-circle"></ion-icon>
                                </i>
                            </div>
                        </div>
                        <div class="form-group basic" @click="backFleet()">
                            <div class="input-wrapper">
                                <label class="form-label fw-bold" for="to">نوع ناوگان</label>
                                <span class="form-control form-select mt-1 text-start" data-bs-toggle="offcanvas"
                                    data-bs-target="#actionSheetForm" href="#">{{ selectedState }}</span>
                                <i class="clear-input">
                                    <ion-icon name="close-circle"></ion-icon>
                                </i>
                            </div>
                        </div>
                        <div class="mt-2">
                            <button type="button" @click.prevent="searchProvince"
                                class="btn background-ORANGE text-light btn-block btn-lg">
                                جستجو
                            </button>
                        </div>
                    </form>
                    <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" id="actionSheetForm">
                        <div class="offcanvas-header background-TEAL">
                            <h5 class="offcanvas-title text-light">انتخاب ناوگان</h5>
                            <a href="#" id="backFleet" class="offcanvas-close" style="display: none"
                                data-bs-dismiss="offcanvas">
                                <ion-icon name="close-outline"></ion-icon>
                            </a>
                        </div>
                        <div class="offcanvas-body">
                            <form>
                                <div class="form-group basic mb-5">
                                    <div class="input-wrapper">
                                        <div class="section full mt-2">
                                            <div class="section-title" style="justify-content: center !important;">لطفا
                                                ناوگان مورد نظر
                                                خود را انتخاب کنید</div>

                                            <div class="accordion" id="accordionExample1">
                                                <div class="accordion-item">
                                                    <h2 class="accordion-header">
                                                        <button class="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#accordion5">
                                                            نیسان و وانت
                                                        </button>
                                                    </h2>
                                                    <div id="accordion5" class="accordion-collapse collapse"
                                                        data-bs-parent="#accordionExample1">
                                                        <div class="accordion-body">
                                                            <div class="input-list">
                                                                <div class="form-check" v-for="fleet in fleets.coms5"
                                                                    :key="fleet.id">
                                                                    <input class="form-check-input" type="radio"
                                                                        name="radioList" :value="fleet.id"
                                                                        :id="'radioList' + fleet.id"
                                                                        v-model="postData.fleet_id"
                                                                        @click="changeTitleFleet(fleet.title)">
                                                                    <label class="form-check-label"
                                                                        :for="'radioList' + fleet.id">{{ fleet.title
                                                                        }}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="accordion-item">
                                                    <h2 class="accordion-header">
                                                        <button class="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#accordion1">
                                                            کامیونت
                                                        </button>
                                                    </h2>
                                                    <div id="accordion1" class="accordion-collapse collapse"
                                                        data-bs-parent="#accordionExample1">
                                                        <div class="accordion-body">
                                                            <div class="input-list">

                                                                <div class="form-check" v-for="fleet in fleets.coms1"
                                                                    :key="fleet.id">
                                                                    <input class="form-check-input" :value="fleet.id"
                                                                        type="radio" name="radioList"
                                                                        @click="changeTitleFleet(fleet.title)"
                                                                        :id="'radioList' + fleet.id"
                                                                        v-model="postData.fleet_id">
                                                                    <label class="form-check-label"
                                                                        :for="'radioList' + fleet.id">{{ fleet.title
                                                                        }}</label>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="accordion-item">
                                                    <h2 class="accordion-header">
                                                        <button class="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#accordion2">
                                                            کامیون 6 چرخ (تک)
                                                        </button>
                                                    </h2>
                                                    <div id="accordion2" class="accordion-collapse collapse"
                                                        data-bs-parent="#accordionExample1">
                                                        <div class="accordion-body">
                                                            <div class="input-list">
                                                                <div class="form-check" v-for="fleet in fleets.coms2"
                                                                    :key="fleet.id">
                                                                    <input class="form-check-input" type="radio"
                                                                        name="radioList" :value="fleet.id"
                                                                        @click="changeTitleFleet(fleet.title)"
                                                                        :id="'radioList' + fleet.id"
                                                                        v-model="postData.fleet_id">
                                                                    <label class="form-check-label"
                                                                        :for="'radioList' + fleet.id">{{ fleet.title
                                                                        }}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="accordion-item">
                                                    <h2 class="accordion-header">
                                                        <button class="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#accordion3">
                                                            کامیون 10 چرخ (جفت)
                                                        </button>
                                                    </h2>
                                                    <div id="accordion3" class="accordion-collapse collapse"
                                                        data-bs-parent="#accordionExample1">
                                                        <div class="accordion-body">
                                                            <div class="input-list">
                                                                <div class="form-check" v-for="fleet in fleets.coms3"
                                                                    :key="fleet.id">
                                                                    <input class="form-check-input" type="radio"
                                                                        name="radioList" :value="fleet.id"
                                                                        @click="changeTitleFleet(fleet.title)"
                                                                        :id="'radioList' + fleet.id"
                                                                        v-model="postData.fleet_id">
                                                                    <label class="form-check-label"
                                                                        :for="'radioList' + fleet.id">{{ fleet.title
                                                                        }}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="accordion-item">
                                                    <h2 class="accordion-header">
                                                        <button class="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#accordion4">
                                                            تریلی
                                                        </button>
                                                    </h2>
                                                    <div id="accordion4" class="accordion-collapse collapse"
                                                        data-bs-parent="#accordionExample1">
                                                        <div class="accordion-body">
                                                            <div class="input-list">
                                                                <div class="form-check" v-for="fleet in fleets.coms4"
                                                                    :key="fleet.id">
                                                                    <input class="form-check-input" type="radio"
                                                                        name="radioList" :value="fleet.id"
                                                                        :id="'radioList' + fleet.id"
                                                                        v-model="postData.fleet_id"
                                                                        @click="changeTitleFleet(fleet.title)">
                                                                    <label class="form-check-label"
                                                                        :for="'radioList' + fleet.id">{{ fleet.title
                                                                        }}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group basic" style=" position: fixed; bottom: 0;">
                                    <button type="button" data-bs-dismiss="offcanvas"
                                        class="btn background-ORANGE text-light btn-block">
                                        ثبت
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="listview-title mt-1">جستجو های اخیر</div>
            <div>
                <p class="text-center" v-if="histories.length <= 0">
                    دیتا یافت نشد
                </p>
                <ul v-else class="listview link-listview">
                    <li v-for="(history, index) in histories" :key="index">
                        <router-link
                            :to="'/searchSelectCities?fleet_id=&selectedLoadingCitiesIds=' + history.from_city_id + '&selectedDischargeCitiesIds=' + history.to_city_id">
                            {{ history?.from_city?.name }} به {{ history?.to_city?.name ?? 'همه' }}
                        </router-link>
                    </li>
                </ul>
            </div>


        </div>
    </div>
</template>
<script>
import SideHeader from '@/components/SideHeader.vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import ListView from '@/components/Placeholder/ListView.vue';
import router from '@/router';

export default {
    components: {
        SideHeader,
        ListView
    },
    data() {
        return {
            cityTo: [],
            cityFrom: [],
            histories: [],
            results: [],
            loading: false,
            selectedState: 'انتخاب کنید',
            postData: {
                selectedLoadingCitiesIds: "",
                selectedDischargeCitiesIds: "",
                fleet_id: "",
            },
            fleets: {
                coms1: [],
                coms2: [],
                coms3: [],
                coms4: [],
                coms5: [],
            },
            axiosConfig: {
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
                    'Accept': 'application/json'
                }
            },
            dataHistory: ''
        }
    },
    methods: {
        getHistories() {
            axios.get("https://core.iran-tarabar.ir/api/driver/historySearchDriver", this.axiosConfig)
                .then((response) => {
                    this.histories = response.data;
                });
        },
        changeTitleFleet(value) {
            this.selectedState = value;
        },
        searchProvince() {
            axios.post("https://core.iran-tarabar.ir/api/driver/historySearchDriver", this.postData, this.axiosConfig)
                .then((response) => {
                });
            this.$router.push("/searchSelectCities?" +
                'fleet_id=' + this.postData.fleet_id + '&' +
                'selectedLoadingCitiesIds=' + this.postData.selectedLoadingCitiesIds + '&' +
                'selectedDischargeCitiesIds=' + this.postData.selectedDischargeCitiesIds
            );
        },
        getFleets() {
            axios.get("https://core.iran-tarabar.ir/api/customer/requestAllFleetsLists")
                .then((response) => {
                    this.fleets.coms1 = response.data.fleets.filter(obj => obj.parent_id == 42);
                    this.fleets.coms2 = response.data.fleets.filter(obj => obj.parent_id == 43);
                    this.fleets.coms3 = response.data.fleets.filter(obj => obj.parent_id == 53);
                    this.fleets.coms4 = response.data.fleets.filter(obj => obj.parent_id == 54);
                    this.fleets.coms5 = response.data.fleets.filter(obj => obj.parent_id == 81);
                })
                .catch(() => {
                    // handle error
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "لطفا اینترنت خود را بررسی کنید",
                        showConfirmButton: true,
                        confirmButtonText: "تایید",
                    });
                });
        },
        cities() {
            this.loading = !this.loading;
            axios.get("https://core.iran-tarabar.ir/api/public/requestProvinceAndCitiesList")
                .then((response) => {
                    this.loading = !this.loading;
                    this.results = response.data.data.provinces;
                })
                .catch(() => {
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "لطفا اینترنت خود را بررسی کنید",
                        showConfirmButton: true,
                        confirmButtonText: "تایید",
                    });
                });
        },
        fleetDefault() {
            axios.get("https://core.iran-tarabar.ir/api/driver/fleetDefault", this.axiosConfig)
                .then((response) => {
                    this.selectedState = response.data.title + ' (پیش فرض) '
                }).catch((error) => {
                    if (error.response.status === 401) {
                        Swal.fire({
                            title: "راننده محترم!",
                            text: "شماره ای که با آن وارد برنامه شده اید، توسط دستگاه دیگری مورد استفاده قرار گرفته است!",
                            icon: "error",
                            confirmButtonColor: "#068b80",
                            confirmButtonText: "ورود مجدد!",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                localStorage.clear();
                                router.push({ name: 'login' })
                            }
                        });

                    }
                });
        },
        backFleet() {
            if (history.pushState) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?backFleet=1';
                window.history.pushState({ path: newurl }, '', newurl);
            }
        }
    },
    mounted() {
        this.cities();
        this.getFleets();
        this.fleetDefault();
        this.getHistories();
    },
}
</script>
<style>
.title-header {
    font-weight: 700 !important;
    margin-bottom: 16px;
    padding-bottom: 7px;
    display: block;
    text-align: start;
    color: #4d4d4d;
}

.link-listview>li {
    border-bottom: 1px solid #e5e5e5;
}
</style>